import authGuard from '@/router/auth-guard'

export default [
  {
    path: '/userSettings',
    name: 'userSettings',
    component: () =>
      import(
        /* webpackChunkName: "usersettings" */ '@/pages/OnBoarding/accounts/userSettings/Main.vue'
      ),
    beforeEnter: authGuard,
    children: [
      {
        path: 'profile',
        name: 'userSettings.profile',
        component: () =>
          import(
            /* webpackChunkName: "usersettings" */ '@/pages/Shared/accounts/userSettings/profile/Profile.vue'
          )
      },
      {
        path: 'accountsecurity',
        name: 'userSettings.accountsecurity',
        component: () =>
          import(
            /* webpackChunkName: "usersettings" */ '@/pages/Shared/accounts/userSettings/accountSecurity/AccountSecurity.vue'
          )
      },
      {
        path: 'twofactorauthentication',
        name: 'userSettings.twofactorauthentication',
        component: () =>
          import(
            /* webpackChunkName: "usersettings" */ '@/pages/Shared/accounts/userSettings/twoFactorAuthentication/index.vue'
          )
      }
    ]
  }
]
